import React from "react";
import RevealOnScroll from "./RevealOnScroll";

const ProblemSection = () => {
  return (
    <section className="section-spacing bg-white">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left side - Problem statement */}
            <RevealOnScroll variant="fade-left">
              <div className="inline-block px-4 py-2 bg-[#4a9da8]/10 text-[#4a9da8] text-sm font-semibold rounded-full mb-6">
                Die Herausforderung
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0f1419] mb-6 leading-tight">
                Viele Unternehmen investieren ohne
                <span className="gradient-text"> klare Strategie</span>
              </h2>
            </RevealOnScroll>

            {/* Right side - Details */}
            <RevealOnScroll variant="fade-right" delay={100}>
            <div className="space-y-6">
              <div className="accent-line p-6 bg-[#f5f5f5] rounded-2xl">
                <p className="text-lg text-[#3a3a3a] leading-relaxed">
                  Viele Unternehmen investieren in Social Media, ohne genau zu wissen, welche Maßnahmen tatsächlich Wirkung zeigen.
                </p>
              </div>
              <div className="accent-line p-6 bg-[#f5f5f5] rounded-2xl">
                <p className="text-lg text-[#3a3a3a] leading-relaxed">
                  Fehlende Struktur und mangelnde Transparenz führen häufig zu Unsicherheit und Streuverlusten.
                </p>
              </div>
            </div>
            </RevealOnScroll>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
